// Ordered library of project cover images.
//
// Images are auto-loaded from this folder — just drop files in (or remove them)
// and they get picked up automatically, no imports to maintain.
//
// Order = alphabetical by filename, and it's what maps each project to a cover
// (projectBackgrounds[index % length]). The backend returns projects in a stable
// order, so a given project keeps the same cover across reloads.
// To force a specific order, prefix filenames with 01_, 02_, 03_, ...

// require.context is provided by webpack (Create React App).
const context = require.context('./', false, /\.(png|jpe?g|webp|svg)$/i);

export const projectBackgrounds = context
  .keys()
  .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
  .map((key) => {
    const mod = context(key);
    return mod && mod.default ? mod.default : mod;
  });

/**
 * Returns the cover image for a project based on its position in the list.
 * @param {number} index - Zero-based index of the project in the ordered list.
 * @returns {string} Imported image URL.
 */
export const getProjectBackground = (index) => {
  const n = projectBackgrounds.length;
  if (n === 0) return undefined;
  return projectBackgrounds[((index % n) + n) % n];
};

export default projectBackgrounds;
